import * as React from 'react';
import icon from '../../assets/img/flags/west-virginia.svg';

export const WestVirginia = (props) => <img src={icon} height={props.height || 100} alt="Flag" />;
